export function parseOrgCustomCategories(browse) {
  return (browse === null || browse === void 0 ? void 0 : browse.org_custom_categories) || [];
}
//# sourceMappingURL=parse-org-custom-categories.js.map